document.addEventListener('teeinblue-event-component-injected', function () {
  function moveElement(sourceSelector, targetSelector, position = 'after') {
    const source = document.querySelector(sourceSelector);
    const target = document.querySelector(targetSelector);

    if (!source || !target) return;

    if (position === 'before') {
      target.before(source);
    } else {
      target.after(source);
    }
  }

  // badge → before #teeFormActions
  moveElement('div[id*=section_store_block_pulse_badge_]', '#teeFormActions', 'before');

  // comments → after #teeFormActions
//   moveElement('div[id*=section_store_block_comments_]', '#teeFormActions', 'after');

});


document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});